var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7822,
    cy: 29.1904,
    r: 28.7451,
    fill: "url(#paint0_linear_14419_10781)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8299 43.1289C29.6733 43.1289 30.3391 43.837 30.3391 44.6846C30.3391 46.8088 29.7473 49.631 29.4957 51.805C29.4513 52.0643 29.2442 52.4233 28.8299 52.4233C28.4895 52.4233 28.238 52.164 28.164 51.8549V51.825V51.795C27.9124 49.5911 27.3206 46.8187 27.3206 44.6746C27.3206 43.837 27.9864 43.1289 28.8299 43.1289Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4761 12.2683C24.2121 21.1737 24.6264 32.4527 25.4699 40.68C27.6894 40.68 29.9534 40.68 32.2173 40.68C33.0163 32.5025 33.4455 21.2535 31.1371 12.2683C30.5008 9.83496 28.3997 4.65922 26.4761 12.2683Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1628 32.4297C34.1628 32.4297 37.8177 38.8221 38.0988 39.4404C38.3948 40.0886 38.4392 40.5174 38.0101 41.6742C37.6253 42.861 37.3738 43.3396 37.3738 43.3396C37.3738 43.3396 33.8077 41.3052 33.1418 40.7667L34.1628 32.4297Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4101 32.4297C23.4101 32.4297 19.7996 38.8221 19.5037 39.4404C19.1633 40.0886 19.1189 40.5174 19.548 41.6742C19.9328 42.861 20.1843 43.3396 20.1843 43.3396C20.1843 43.3396 23.7504 41.3052 24.4163 40.7667L23.4101 32.4297Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14419_10781",
    x1: 57.5273,
    y1: 57.9355,
    x2: 0.0267969,
    y2: 0.455629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D54DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C58EF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.69e82ab35b2d9cb8ccbce1cc4e9c2c2e.svg";
export { ForwardRef as ReactComponent };